export default [

     {
          path: '/sector',
          name: 'Sector',
          component: () => import("@/views/Page/Sector/Sector.vue"),
          meta: {
               title: 'Sector',
          },
     }
];